import { render, staticRenderFns } from "./FeatureImageViewer.vue?vue&type=template&id=033d4006&scoped=true&"
import script from "./FeatureImageViewer.vue?vue&type=script&lang=ts&"
export * from "./FeatureImageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureImageViewer.vue?vue&type=style&index=0&id=033d4006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d4006",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
